import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface ICreateAdminProfileParams {
  name: string;
  description: string;
  permissions: Array<{
    capability: string;
    resource: string;
  }>;
}

export interface ICreateAdminProfileResult extends IResult {
  luid: string;
}

export class CreateAdminProfileRequest extends Request<ICreateAdminProfileParams, ICreateAdminProfileResult> {
  constructor(params: ICreateAdminProfileParams) {
    super('createAdminProfile', params);
  }
}
